import React from 'react';
import {
  QUIZ_TEMPLATES,
  addQuizOption,
  removeQuizOption,
} from '../../utils/quizForm';

const MCQForm = ({
  mcqQuestion,
  setMCQQuestion,
  options,
  setOptions,
  mcqExplanation,
  setMCQExplanation,
  mcqtags,
  setmcqtags,
  selectedTemplate,
  handleInputChange,
  handleMCQtagChange,
  addMCQtag,
  isQuiz = false,
  quizOptions = [],
  setQuizOptions,
  quizTemplate = QUIZ_TEMPLATES.SINGLE,
  setQuizTemplate,
}) => {
  const updateQuizOptionText = (optionId, text) => {
    setQuizOptions((prev) =>
      prev.map((option) =>
        option.id === optionId ? { ...option, text } : option
      )
    );
  };

  const toggleQuizCorrect = (optionId) => {
    setQuizOptions((prev) =>
      prev.map((option) => {
        if (quizTemplate === QUIZ_TEMPLATES.SINGLE) {
          return { ...option, correct: option.id === optionId };
        }
        if (option.id !== optionId) return option;
        return { ...option, correct: !option.correct };
      })
    );
  };

  const handleTemplateChange = (nextTemplate) => {
    setQuizTemplate(nextTemplate);
    if (nextTemplate === QUIZ_TEMPLATES.SINGLE) {
      setQuizOptions((prev) => {
        const firstCorrect = prev.find((option) => option.correct);
        return prev.map((option, index) => ({
          ...option,
          correct: firstCorrect
            ? option.id === firstCorrect.id
            : index === 0,
        }));
      });
    }
  };

  return (
    <div className="container-fluid p-1">
      <div className="d-flex justify-content-end mb-2">
      </div>
      <form
        className="shadow px-2 py-2 rounded border"
        style={{backgroundColor: '#f7f7f766'}}
        onSubmit={(event) => event.preventDefault()}
      >
        <div className="mb-3">
          <label htmlFor="question" className="form-label">
            Question:
          </label>
          <textarea
            id="question"
            name="question"
            className="form-control custom-input"
            value={mcqQuestion}
            onChange={handleInputChange}
            placeholder="Enter the question"
            rows={5} 
            required
          />
        </div>

        {isQuiz ? (
          <>
            <div className="mb-3">
              <label className="form-label">Answer type</label>
              <div className="d-flex gap-3">
                <label className="form-check-label d-flex align-items-center gap-2">
                  <input
                    type="radio"
                    className="form-check-input"
                    checked={quizTemplate === QUIZ_TEMPLATES.SINGLE}
                    onChange={() => handleTemplateChange(QUIZ_TEMPLATES.SINGLE)}
                  />
                  Single choice
                </label>
                <label className="form-check-label d-flex align-items-center gap-2">
                  <input
                    type="radio"
                    className="form-check-input"
                    checked={quizTemplate === QUIZ_TEMPLATES.MULTIPLE}
                    onChange={() => handleTemplateChange(QUIZ_TEMPLATES.MULTIPLE)}
                  />
                  Multiple choice
                </label>
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label">
                Options : (mark correct answer{quizTemplate === QUIZ_TEMPLATES.MULTIPLE ? 's' : ''})
              </label>
              {quizOptions.map((option, index) => (
                <div key={option.id} className="d-flex align-items-start gap-2 mb-2">
                  <input
                    type={quizTemplate === QUIZ_TEMPLATES.MULTIPLE ? 'checkbox' : 'radio'}
                    name="quiz-correct"
                    className="form-check-input mt-2"
                    checked={Boolean(option.correct)}
                    onChange={() => toggleQuizCorrect(option.id)}
                    aria-label={`Mark option ${index + 1} correct`}
                  />
                  <textarea
                    className="form-control custom-input"
                    value={option.text}
                    onChange={(event) =>
                      updateQuizOptionText(option.id, event.target.value)
                    }
                    placeholder={`Option ${index + 1}`}
                    rows={2}
                    style={{
                      border: option.correct ? '3px solid green' : '1px solid #00000024',
                      whiteSpace: 'pre-wrap',
                      fontFamily: 'monospace',
                      fontSize: '14px',
                    }}
                    required
                  />
                  <button
                    type="button"
                    className="btn btn-outline-danger btn-sm mt-1"
                    disabled={quizOptions.length <= 2}
                    onClick={() =>
                      setQuizOptions((prev) => removeQuizOption(prev, option.id))
                    }
                  >
                    Remove
                  </button>
                </div>
              ))}
              <button
                type="button"
                className="btn text-light btn-sm mt-1"
                style={{ backgroundColor: '#377383' }}
                onClick={() => setQuizOptions((prev) => addQuizOption(prev))}
              >
                Add option
              </button>
            </div>
          </>
        ) : (
          <div className="mb-3">
            <label className="form-label">Options : (Option 1 is correct)</label>
            <div className="row">
              {["option1", "option2", "option3", "option4"].map(
                (option, index) => (
                  <div key={index} className="col-lg-6 col-12 mb-2">
                    <pre>
                      <textarea
                        name={option}
                        className={`form-control custom-input ${option === "option1" ? "highlighted" : ""}`}
                        value={options[option]}
                        style={{
                          border: option === "option1" ? "3px solid green" : "1px solid #00000024",
                          width: '100%',
                          height: '100%',
                          whiteSpace: 'pre-wrap',
                          fontFamily: 'monospace',
                          fontSize: '14px',
                        }}
                        onChange={handleInputChange}
                        placeholder={`Option ${index + 1}`}
                        required
                      />
                    </pre>
                  </div>
                )
              )}
            </div>
          </div>
        )}
        
        <div className="mb-3">
          <label htmlFor="explanation" className="form-label custom-input">
            Explanation:
          </label>
          <textarea
            id="explanation"
            name="explanation"
            className="form-control custom-input"
            value={mcqExplanation}
            onChange={handleInputChange}
            placeholder="Provide an explanation for the correct answer"
            rows="4"
            required
          />
        </div>

        <div className="mb-4">
          <h5 className="text-muted">Enter Tags :</h5>
          {mcqtags.map((tag, index) => (
            <div
              key={index}
              className="mb-3 position-relative"
            >
              <div className="form-group">
                <label htmlFor={`tag${index}`}>
                  Tag {index + 1}:
                </label>
                <input
                  type="text"
                  id={`tag${index}`}
                  className="form-control custom-input mb-2"
                  value={tag}
                  onChange={(e) =>
                    handleMCQtagChange(index, e.target.value)
                  }
                  placeholder="Enter tag"
                />
                <button
                  type="button"
                  className="btn-close position-absolute top-0 end-0"
                  aria-label="Close"
                  onClick={() => {
                    setmcqtags((prevtags) =>
                      prevtags.filter((_, i) => i !== index)
                    );
                  }}
                />
              </div>
            </div>
          ))}
          <button
            className="btn text-light btn-sm mt-1"
            style={{ backgroundColor: "#377383" }}
            onClick={addMCQtag}
            type="button"
          >
            Add Tag
          </button>
        </div>
      </form>
    </div>
  );
};

export default MCQForm;
